
import {of as observableOf,  Observable } from 'rxjs';

import {catchError, map, switchMap} from 'rxjs/operators';
import { Directive, Input, forwardRef } from '@angular/core';
import { AbstractControl, NG_ASYNC_VALIDATORS } from '@angular/forms';
import { CaptchaService } from './captcha.service';
import { Router } from '@angular/router';


const CAPTCHA_LENGTH = 5;
const CAPTCHA_MAX_RETRY_EXCEEDED_ERROR_CODE = '1041';

@Directive({
    selector: '[jhiCaptchaValidator][ngModel]',
    providers: [
        { provide: NG_ASYNC_VALIDATORS, useExisting: forwardRef(() => CaptchaValidatorDirective), multi: true }
    ]
})
export class CaptchaValidatorDirective {

    @Input()
    redirectAfterMaxRetryPath: string;

    @Input()
    email: string;

    constructor(private captchaService: CaptchaService, private router: Router) { }

    validate(c: AbstractControl): Promise<{ [key: string]: any } | null> | Observable<{ [key: string]: any } | null> {
        if (!c.value) {
            return observableOf(null);
        }

        if (c.value.length !== CAPTCHA_LENGTH) {
            return observableOf({ 'invalid-captcha': true });
        }

        return observableOf(c.value).pipe(
            switchMap(
                captcha => this.captchaService.isValid(captcha, this.email || '').pipe(
                    map(isValid => isValid === 'true' ? null : { 'invalid-captcha': true }),
                    catchError(err => {
                        if (err.status === 400 && err.code === CAPTCHA_MAX_RETRY_EXCEEDED_ERROR_CODE) {
                            this.router.navigate([this.redirectAfterMaxRetryPath || '/']);
                        }
                        return observableOf({ 'invalid-captcha': true });
                    }))
            ));
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/captcha/captcha-validator.ts